import { render, staticRenderFns } from "./Scoreboard.vue?vue&type=template&id=00d3953d&scoped=true"
import script from "./Scoreboard.vue?vue&type=script&lang=ts"
export * from "./Scoreboard.vue?vue&type=script&lang=ts"
import style0 from "./Scoreboard.vue?vue&type=style&index=0&id=00d3953d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d3953d",
  null
  
)

export default component.exports